/**
 * Logic module types for the planner application
 */ export var LogicModule = /*#__PURE__*/ function(LogicModule) {
    /** Adaptive Card Module */ LogicModule["AdaptiveCard"] = "adaptiveCard";
    /** App Context Module */ LogicModule["AppContext"] = "appContext";
    /** Auth Module */ LogicModule["Auth"] = "auth";
    /** Bucket Module */ LogicModule["Bucket"] = "bucket";
    /** Campaign Module */ LogicModule["Campaign"] = "campaign";
    /** Custom Field Definition Module */ LogicModule["CustomFieldDefinition"] = "customFieldDefinition";
    /** Capabilities Module */ LogicModule["Capabilities"] = "capabilities";
    /** Centro Module */ LogicModule["Centro"] = "centro";
    /** Chat Module */ LogicModule["Chat"] = "chat";
    /** Chat Service Aggregator Module  */ LogicModule["ChatSvcAgg"] = "chatSvcAgg";
    /** Dependency Module */ LogicModule["Dependency"] = "dependency";
    /** DriveItem Module */ LogicModule["DriveItem"] = "driveItem";
    /** External Agents Module */ LogicModule["ExternalAgents"] = "externalAgents";
    /** Goal Module */ LogicModule["Goal"] = "goal";
    /** Modern Group Module */ LogicModule["ModernGroup"] = "modernGroup";
    /** Grounding resource module */ LogicModule["GroundingResource"] = "groundingResource";
    /** Intelligence Module */ LogicModule["Intelligence"] = "intelligence";
    /** Links Module */ LogicModule["Links"] = "links";
    /** Loop Module */ LogicModule["Loop"] = "loop";
    /** Mru Module */ LogicModule["Mru"] = "mru";
    /** Notification Module */ LogicModule["Notification"] = "notification";
    /** Org Module */ LogicModule["Org"] = "org";
    /** Performance Collection Module */ LogicModule["PerformanceCollection"] = "performanceCollection";
    /** Plan Module */ LogicModule["Plan"] = "plan";
    /** Plan Conversion Module */ LogicModule["PlanConversion"] = "planConversion";
    /** GroupConversations Module */ LogicModule["GroupConversations"] = "groupConversations";
    /** Portfolio Module */ LogicModule["Portfolio"] = "portfolio";
    /** Roaming Module */ LogicModule["Roaming"] = "roaming";
    /** PlanAi Module */ LogicModule["PlanAi"] = "planAi";
    /** Premium Plan Module */ LogicModule["PremiumPlan"] = "premiumPlan";
    /** Premium Task Module */ LogicModule["PremiumTask"] = "premiumTask";
    /** Roster Module */ LogicModule["Roster"] = "roster";
    /** Sensitivity User Rights Module */ LogicModule["SensitivityUserRights"] = "sensitivityUserRights";
    /** SuiteNav Module */ LogicModule["SuiteNav"] = "suiteNav";
    /** Task Module */ LogicModule["Task"] = "task";
    /** Teams Module */ LogicModule["Teams"] = "teams";
    /** Teams Tasks Tabs Module */ LogicModule["TeamsTasksTabs"] = "teamsTasksTabs";
    /** Template Module */ LogicModule["Template"] = "template";
    /** Tenant Module */ LogicModule["Tenant"] = "tenant";
    /** Todo Module */ LogicModule["Todo"] = "todo";
    /** Trouter Module */ LogicModule["Trouter"] = "trouter";
    /** Upsell Module */ LogicModule["Upsell"] = "upsell";
    /** User Module */ LogicModule["User"] = "user";
    /** View lifecycle */ LogicModule["ViewLifecycle"] = "viewLifecycle";
    /** Scenario modules, for modules referencing multiple other modules */ /** Bucket Scenario Module */ LogicModule["BucketScenario"] = "bucketScenario";
    /** Data Integrity Scenario Module */ LogicModule["DataIntegrityScenario"] = "dataIntegrityScenario";
    /** Capabilities Scenario Module */ LogicModule["CapabilitiesScenario"] = "capabilitiesScenario";
    /** Container Scenario Module */ LogicModule["ContainerScenario"] = "containerScenario";
    /** Create Task From Teams Message Scenario Module */ LogicModule["CreateTaskFromTeamsMessageScenario"] = "createTaskFromTeamsMessageScenario";
    /** Chat Scenario Module */ LogicModule["ChatScenario"] = "chatScenario";
    /** Copilot Scenario Module */ LogicModule["CopilotScenario"] = "copilotScenario";
    /** Conversion Scenario Module */ LogicModule["ConversionScenario"] = "conversionScenario";
    /** Custom Field Definition Scenario Module */ LogicModule["CustomFieldDefinitionScenario"] = "customFieldDefinitionScenario";
    /** Export Scenario Module */ LogicModule["ExportScenario"] = "exportScenario";
    /** Goal Scenario Module */ LogicModule["GoalScenario"] = "goalScenario";
    /** Grounding Resource Scenario Module */ LogicModule["GroundingResourceScenario"] = "groundingResourceScenario";
    /** Modal Scenario Module */ LogicModule["ModalScenario"] = "modalScenario";
    /** Modern Group Conversation Scenario Module */ LogicModule["ModernGroupConversationScenario"] = "modernGroupConversationScenario";
    /** Modern Group Scenario Module */ LogicModule["ModernGroupScenario"] = "modernGroupScenario";
    /** Mru Scenario Module */ LogicModule["MruScenario"] = "mruScenario";
    /** Plan Scenario Module */ LogicModule["PlanScenario"] = "planScenario";
    /** Routing Module */ LogicModule["RoutingScenario"] = "routingScenario";
    /** Status Report Scenario Module */ LogicModule["StatusReportScenario"] = "statusReportScenario";
    /** Task Scenario Module */ LogicModule["TaskScenario"] = "taskScenario";
    /** Teams Scenario Module */ LogicModule["TeamsScenario"] = "teamsScenario";
    /** Teams Tab Scenario Module */ LogicModule["TeamsTabScenario"] = "teamsTabScenario";
    /** Template Scenario Module */ LogicModule["TemplateScenario"] = "templateScenario";
    /** Tenant Scenario Module */ LogicModule["TenantScenario"] = "tenantScenario";
    /** Todo Scenario Module */ LogicModule["TodoScenario"] = "todoScenario";
    /** Trouter Scenario Module */ LogicModule["TrouterScenario"] = "trouterScenario";
    return LogicModule;
}({});
